<template>
  <div>
    <vs-dialog v-model="showLogin" width="468px" @close="closeDia">
      <div class="login-form">
        <img class="login-logo" v-if="store.state.user.language=='zh-CN'" src="@/assets/images/mydosoLogoWeb.png" alt="">
        <img class="login-logo" v-else src="@/assets/images/mydosoLogoTWWeb.png" alt="">
        <div class="login-qrcode" v-if="loginType == 'wechat'">
          <div id="login_container" style="height: 190px;" v-if="loginType == 'wechat'"></div>
          <span style="font-size: 14px; font-weight: bold; color: #999999">{{ $t('msg.other.请使用微信扫描二维码登入') }}</span>
        </div>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          v-if="loginType == 'mobile'"
        >
          <el-form-item prop="mobile">
              <el-input v-model="form.mobile" type="text" autocomplete="off" :placeholder="$t('msg.login.mobile_pla')">
                <template #prefix>
                  <span style="display: inline-flex; align-items: center;">
                    <img class="input-prefix" src="@/assets/images/icons/profile-circle.png" alt="">
                    <el-dropdown  v-if="isCode"  @command="dropdownSelectedPlatform" placement="bottom-start">
                      <div style="display:flex;align-items:center;height:35px;line-height:35px;">
                        <span class="nohover">+{{ countryCode}}</span>
                        <el-icon style="margin-left:4px;"><ArrowDown /></el-icon>
                      </div>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item command="86" :class="{'dropdown_select': countryCode === '86'}">简体中文（人民币支付）</el-dropdown-item>
                          <el-dropdown-item command="886" :class="{'dropdown_select': countryCode === '886'}">繁體中文（新台幣支付）</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code" v-if="isCode">
            <el-input v-model="form.code" type="text" autocomplete="off" :placeholder="$t('msg.login.code_pla')">
              <template #prefix>
                <img class="input-prefix" src="@/assets/images/icons/unlock.png" alt="">
              </template>
              <template #suffix>
                <div class="vs-button cursor-pointer vs-button--default" :disabled="smsLoading" @click="sendCode"><div class="vs-button__content" style="padding: 2px 12px"> {{ countDown > 0 ? `${countDown} ${$t('msg.login.send_code')}` : $t('msg.login.get_code') }}</div></div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" v-else>
            <el-input v-model="form.password" type="password" autocomplete="off" :placeholder="$t('msg.login.password_pla')">
              <template #prefix>
                <img class="input-prefix" src="@/assets/images/icons/unlock.png" alt="">
              </template>
              <template #suffix>
                <div class="input-suffix">{{$t('msg.login.forget_password')}}？</div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <vs-button block v-if="loginType == 'mobile'" :class="isQuickLogon ? 'vs-button--shadow mt24': 'vs-button--active'"
        :loading="btnLoading" @click="confirmLogin">{{!isCode? $t('msg.login.password'):$t('msg.login.phone_code')}}登入</vs-button>
        <!-- <vs-button v-if="countryCode === '886'" block @click="isQuickLogon = true" :class="isQuickLogon ? ' vs-button--active  mt24': 'vs-button--shadow  mt24'">LINE登入</vs-button>
        <vs-button  v-if="countryCode === '86'" block @click="isQuickLogon = true" :class="isQuickLogon ? ' vs-button--active  mt24': 'vs-button--shadow  mt24'">微信登入</vs-button> -->
      </div>
      <div class="other-logins">
        <div v-if="countryCode === '86'" class="other-item" @click="wechatLogin">
          <img src="@/assets/images/icons/wechat-login.png" alt="">
          <span>微信登入</span>
        </div>
        <div v-else class="other-item" @click="lineLogin">
          <img src="@/assets/images/icons/line-login.png" alt="">
          <span>LINE登入</span>
        </div>
        <div class="other-item" @click="isCode=false; loginType = 'mobile'" >
          <div class="justifyContentCenter pas-icon">
              <img src="@/assets/images/icons/lock-fill2.png" alt="">
          </div>
          <span>{{$t('msg.login.password')}}登入</span>
        </div>
        <!-- <div class="other-item">
          <img src="@/assets/images/icons/fb-login.png" alt="">
          <span>FB登入</span>
        </div> -->
        <div class="other-item" @click="isCode=true; loginType = 'mobile'">
          <img src="@/assets/images/icons/strick-login.png" alt="">
          <span>{{ $t('msg.login.phone_code') }}</span>
        </div>
      </div>
      <template #footer>
        <div class="tips-text">{{$t('msg.login.tips_text')}}</div>
      </template>
    </vs-dialog>
  </div>
</template>
<script lang='ts' setup>
import {ArrowDown} from '@element-plus/icons-vue'
import {computed, nextTick, ref, watch} from 'vue'
import {useStore} from 'vuex'
import userService from '@/services/user'
import {setToken} from '@/utils/auth'
import {ElMessage} from 'element-plus'
import querystring from "querystring";
import {useI18n} from "vue-i18n";

const {mobileLogin,getUserInfo,sendSms,userNameLogin} = userService
const store = useStore()
const showLogin = computed(() => store.state.user.showLogin || false)
console.log('showLogin', showLogin, store);
const { t } = useI18n();
const isCode = ref(true)
const loginType = ref('mobile')
// 18842262566
// 678321
const form = ref({mobile:'',code:'',password:''})
const showModel = ref(false)
const smsLoading = ref(false)
const btnLoading = ref(false)
const formRef = ref()
const countryCode = computed(() => store.state.user.language === 'zh-CN' ? '86': '886')
const isQuickLogon = ref(false)

const rules = ref({
  mobile: { required: true, message: t('msg.login.mobile_pla'), trigger: 'blur' },
  code: { required: true, message: t('msg.login.code_pla'), trigger: 'blur' },
  password: { required: true, message:  t('msg.login.password_pla'), trigger: 'blur' },
})
const dropdownSelectedPlatform = (val) => {
  rules.value.mobile.message = val === '86'?'请输入手机号':'請輸入手機號';
  rules.value.code.message = val === '86'?'请输入验证码':'請輸入驗證碼';
  rules.value.password.message = val === '86'?'请输入密码':'請輸入密碼';
  store.dispatch('user/setPlatform', val === '86' ? 'zh-CN': 'zh-TW')
  store.dispatch('user/setLanguage',  val === '86' ? 'zh-CN': 'zh-TW')
}

watch(()=>showLogin,(newVal) => {
  console.log(newVal);

})
const closeDia = () => {
  store.dispatch('user/setLoginShow', false)
}
const timer:any = ref(null)
const countDown = ref(0)
const startCountDown = () => {
    // 如果倒计时没有在进行中
    if (countDown.value === 0) {
        countDown.value = 60; // 设置初始倒计时时间
        // countDown.value = 10; // 设置初始倒计时时间
        // 启动定时器，每秒更新倒计时
        timer.value = setInterval(() => {
        if (countDown.value > 0) {
            countDown.value--;
        } else {
            // 倒计时结束，清除定时器
            smsLoading.value = false;
            clearInterval(timer.value);
            timer.value = null;
        }
        }, 1000);
    }
}
const sendCode = async () => {
  if (!form.value.mobile) {
    return ElMessage.error(countryCode.value === '86'?'请输入手机号':'請輸入手機號')
  }
  if(smsLoading.value){
    return ;
  }
  // if (countDown.value > 0) return
  try {
    const captcha = new TencentCaptcha('190627459', callback, {});
    captcha.show();
  } catch (error) {
    loadErrorCallback();
  }
}

function loadErrorCallback() {
  var appid = '190627459';
  var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
  callback({
    ret: 0,
    randstr: '@' + Math.random().toString(36).substr(2),
    ticket: ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error',
  });
}

const tencentData = ref({})
async function callback(res) {
  tencentData.value = {...res}

  if (countDown.value > 0) return
  try {
    const params = {
      mobile: form.value.mobile,
      type: 'login', // bind_mobile 绑定手机 change_mobile_check_old 修改绑定手机 验证旧手机
      ticket: tencentData.value.ticket,
      randstr: tencentData.value.randstr,
      country_code: countryCode.value, // 86 或者 '886'
    }
    sendSms(params).then(res => {
      if(res.data.code == 0){
        smsLoading.value = true;
        startCountDown()
      }
    })
  } catch(err) {
    console.log('err',err)
  }
}

const confirmLogin = async () => {
  if (!formRef.value) return
  await formRef.value.validate((valid, fields) => {
    if (valid) {
      if (!isCode.value) {
        let params = {
          email: form.value.mobile,
          password:form.value.password,
        }
        btnLoading.value = true
        userNameLogin(params).then(res=>{
          let data = res.data.result
          store.dispatch('user/setUserInfo', data)
          store.dispatch('user/setToken', data.token)
          store.dispatch('user/setLoginShow', false)
          setToken(data.token)
          btnLoading.value = false
          getUserInfo().then(res=>{
            store.dispatch('user/setUserInfo', res.data.result)
            window.location.reload()
          })
        }).catch(err=>{
          console.log('err', err);
          btnLoading.value = false

        })
      } else {
        let params = {
          mobile: form.value.mobile,
          // password: md5(form.value.password),
          // mobile: formState.mobile,
          code: form.value.code,
          type: 'login',
          country_code: countryCode.value, // 86 或者 '886'
        }
        btnLoading.value = true
        mobileLogin(params).then(res=>{
          let data = res.data.result
          store.dispatch('user/setUserInfo', data)
          store.dispatch('user/setToken', data.token)
          store.dispatch('user/setLoginShow', false)
          setToken(data.token)
          btnLoading.value = false
          getUserInfo().then(res=>{
            store.dispatch('user/setUserInfo', res.data.result)
            window.location.reload()
          })
        }).catch(err=>{
          console.log('err');
          btnLoading.value = false

        })
      }
    }
  })
}

const wechatLogin = () => {
  loginType.value = 'wechat';
  nextTick(() => {
    var obj = new WxLogin({
      self_redirect: true,
      id:"login_container",
      appid: "wx67a1b4ee5e22f0b0",
      scope: "snsapi_login",
      redirect_uri: "https://www.mydoso.com/wechat_login",
      state: "123",
      stylelite: 1,
      onReady: function(isReady){
        console.log(isReady);
      }
    });
  })
}

const lineLogin = () => {
  const clientId = "2006147278"; // 你的 Channel ID
  const state = "12345abcde"; // 随机字符串防CSRF，生产环境请动态生成并保存session
  const nonce = "09876xyz";   // 随机字符串，用于验证id_token

  // const callback_url = window.location.origin + '/line_callback'
  const callback_url = 'https://www.mydoso.com/line_callback'
  console.log('aa', {
    response_type: "code",
    client_id: clientId,
    redirect_uri: callback_url,
    state,
    scope: "profile openid",
    nonce
  })
  const params = querystring.stringify({
    response_type: "code",
    client_id: clientId,
    redirect_uri: callback_url,
    prompt: 'login',
    initial_amr_display: 'lineqr',
    state,
    scope: "profile openid",
    nonce
  });
  localStorage.setItem('lineRedirectUrl', window.location.href)
  window.location.href = `https://access.line.me/oauth2/v2.1/authorize?${params}`;
}

watch(() => showLogin.value, (newValue) => {
  loginType.value = 'mobile'
})

</script>
<style lang='scss' scoped>
.pas-icon{
  background: #4DC9FF; width: 48px; height: 48px; border-radius: 50%; text-align: center;
  img{
    width: 20px;
    height: 20px;
  }
}
.login-form {
  @include flexColumn(center);
  padding-top: 50px;
  width: 326px;
  margin: auto;
  .input-prefix {
    width: 20px;
  }
  .input-suffix {
    font-size: 12px;
    color: $grey;
    font-weight: 400;
  }
  :deep(.el-form-item.is-error .el-input__wrapper) {
    box-shadow: none;
  }
  :deep(.el-form) {
    width: 100%;
    margin-top: 48px;
    margin-bottom: 15px;
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-input__wrapper {
      box-shadow: none;
      border-bottom: 1px solid #F2F2F2;
      height: 56px;
      font-size: 14px;
      font-weight: 600;
    }
    .el-input__inner {
      &::placeholder {
        font-weight: 400;
      }
    }
  }
}
.login-logo {
  height: 56px;
}
.tips-text {
  font-size: 12px;
  color: $grey;
  text-align: center;
}
.other-logins {
  @include flexRow(center);
  margin: 30px 0 24px;
  .other-item {
    @include flexColumn(center);
    font-size: 12px;
    cursor: pointer;
    margin-right: 24px;
    &:last-of-type {
      margin-right: 0;
    }
    &>img {
      width: 48px;
      height: 48px;
    }
    &>span {
      color: $grey;
      margin-top: 8px;
    }
  }
}
.login-qrcode{
  margin-top: 20px;
  padding-top: 20px;
  //background: #f8f8f8;
  border-radius: 10px;
  text-align: center;
}
</style>
<style lang="scss">
.login-qrcode{
  iframe{
    max-height: 220px;
    width: 326px;
  }
}
</style>